import * as Styled from 'components/list-item/styled';

const ListItem = Styled.ListItem;
const ListItemStyles = Styled.ListItemStyles;

const Root = ListItem;

export {
    ListItem,
    ListItemStyles,
    //
    Root,
};
